import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=00978af7&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=00978af7&prod&scoped=true&lang=less"
import style1 from "./FileUpload.vue?vue&type=style&index=1&id=00978af7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00978af7",
  null
  
)

export default component.exports